<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            text-key="title"
            value-key="id"
            :search="true"
            :multiple="multiple"
  >

    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).title}}
    </template>

  </fvSelect>
</template>

<script>
	import {mapActions} from "vuex"
	import {API_MEDIA_URL} from "../env"

	export default {

		props: {
			multiple: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String
			},
			id: {
				type: String
			},
			value: {
				type: [Array, String],
			},
			required: [Boolean, Function],
			justId: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				...mapActions('main', [
					'crud'
				]),
				options: [],
				media_url: API_MEDIA_URL
			}
		},
		created() {
			this.getData()
		},
		computed: {
			valData: {
				get() {
					return this.value ? this.justId ? [this.value] : this.value : this.multiple ? [] : undefined
				},
				set(value) {
					const data = this.multiple ? value : [value]
					const result = this.justId ? data[0] : data
					this.$emit('input', result)
				}
			}
		},
		methods: {
			findValueObject(value) {
				if (this.multiple)
					return this.options.find((option) => option.id === value) || false;
				else
					return this.options.find((option) => option.id === value[0]) || false;
			},
			async getData() {
				try {
					const plans = await this.crud({
						action: 'get',
						section: 'plans',
					})
					this.options = plans.data.items
				} catch (e) {
					// console.log(e)
				}
			}
		}
	}
</script>

<style lang="scss">

</style>
